import { Delete as DeleteIcon } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import CustomerSelect from "../../components/customerSelect/CustomerSelect";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import { usePackageCustomers } from "./usePackageCustomers";

const AddCustomerFooter: FC<{
  onAdd: (customer: { customerId: string; description: string; link: string }) => Promise<void>;
}> = ({ onAdd }) => {
  const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null);
  const [description, setDescription] = useState("");
  const [link, setLink] = useState("");
  const handleAdd = async () => {
    await onAdd({
      customerId: selectedCustomer ?? "",
      description,
      link,
    });
    setDescription("");
    setLink("");
    setSelectedCustomer(null);
  };
  return (
    <TableFooter>
      <TableRow>
        <TableCell>
          <CustomerSelect customerId={selectedCustomer} onChange={setSelectedCustomer} />
        </TableCell>
        <TableCell>
          <TextField fullWidth label="Opis" value={description} onChange={(e) => setDescription(e.target.value)} />
        </TableCell>
        <TableCell>
          <TextField
            fullWidth
            label="Link do oferty"
            value={link}
            type="url"
            onChange={(e) => setLink(e.target.value)}
          />
        </TableCell>
        <TableCell>
          <AsyncLoadingButton
            color="primary"
            variant="outlined"
            disabled={!selectedCustomer || !description || !link}
            onClick={handleAdd}
          >
            Dodaj klienta
          </AsyncLoadingButton>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
};

interface Props {
  packageId: string;
}

const PackageCustomers: FC<Props> = ({ packageId }) => {
  const { isLoading, customers, addPackageCustomer, deletePackageCustomer } = usePackageCustomers(packageId);
  return (
    <>
      <Grid size={12}>
        <Typography variant="h6">Klienci oferujący pakiet</Typography>
      </Grid>
      {isLoading && (
        <Grid size={12}>
          <LinearProgress />
        </Grid>
      )}
      {!isLoading && (
        <Grid size={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Klient</TableCell>
                <TableCell>Opis</TableCell>
                <TableCell>Link</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((c) => (
                <TableRow key={c.customerId} data-testid="package-customer-row">
                  <TableCell>{c.name}</TableCell>
                  <TableCell>{c.description}</TableCell>
                  <TableCell>{c.link}</TableCell>
                  <TableCell>
                    <IconButton aria-label="Usuń klienta" onClick={() => deletePackageCustomer(c.customerId)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <AddCustomerFooter
              onAdd={async (r) => {
                await addPackageCustomer(r);
              }}
            />
          </Table>
        </Grid>
      )}
    </>
  );
};

export default PackageCustomers;
